"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDiffs = exports.getDiff = exports.showDiff = void 0;
var diff_1 = require("./diff");
Object.defineProperty(exports, "showDiff", { enumerable: true, get: function () { return diff_1.showDiff; } });
Object.defineProperty(exports, "getDiff", { enumerable: true, get: function () { return diff_1.getDiff; } });
Object.defineProperty(exports, "getDiffs", { enumerable: true, get: function () { return diff_1.getDiffs; } });
